var exports = {
  "uW": "EarnableBadges.module__section___eWtHWl",
  "DD": "EarnableBadges.module__title___eWtHWl",
  "p_": "EarnableBadges.module__list___eWtHWl",
  "AS": "EarnableBadges.module__item___eWtHWl",
  "Qw": "EarnableBadges.module__art___eWtHWl",
  "Qq": "EarnableBadges.module__text___eWtHWl",
  "UU": "EarnableBadges.module__name___eWtHWl",
  "Tx": "EarnableBadges.module__how___eWtHWl",
  "XI": "EarnableBadges.module__action___eWtHWl",
};

module.exports = exports;
